import type { AuthError } from "@/types/auth";

export function ErrorPanel({ error }: { error: AuthError }) {
  const errorSource = error.source ?? error.kind ?? "auth";

  return (
    <main className="app-shell">
      <section className="panel narrow">
        <p className="eyebrow danger">Authentication error</p>
        <h1>Sign-in could not complete</h1>
        <p className="muted">{error.message}</p>
        <dl className="details-list">
          <div>
            <dt>Source</dt>
            <dd>{errorSource}</dd>
          </div>
        </dl>
        <button className="button secondary" onClick={() => window.location.assign("/")}>
          Return to start
        </button>
      </section>
    </main>
  );
}
